import { useState, useEffect } from "react";
import './Credenziali.css';
import api from "../../api.js";
import axios from 'axios';
import ConfirmModal from "../ConfirmModal/ConfirmModal.js";

export default function Credenziali() {
  const [progetti, setProgetti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [inizialProject, setInizialProject] = useState([]);
  const [filterQuery, setFilterQuery] = useState('');
  const [showPasswords, setShowPasswords] = useState({});
  const [copiedId, setCopiedId] = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  useEffect(() => {
    const emailq = localStorage.getItem('email');
    axios.post(`${api()}/credenziali/getCredenziali`, { email: emailq }, {
      headers: {
        authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then((response) => {
        let items = response.data || [];
        items.forEach((element, i) => {
          element.id = i + 1;
        });
        setProgetti(items);
        setInizialProject(items);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="progetti-loading">
        <div className="spinner"></div>
        <p>Caricamento credenziali in corso...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="progetti-error-box">
        <h3>Si è verificato un errore</h3>
        <p>{error.message}</p>
        <button onClick={() => window.location.reload()} className="btn-retry">Riprova</button>
      </div>
    );
  }

  const requestDelete = (p) => {
    setDeleteTarget({
      id: p.id,
      _id: p._id,
      name: p.servizio || `Credenziale #${p.id}`
    });
  };

  const confirmDelete = () => {
    if (!deleteTarget) return;
    deleteRow(deleteTarget.id, deleteTarget._id);
    setDeleteTarget(null);
  };

  const deleteRow = (id, _id) => {
    const progettiCopy = [...progetti];
    const index = progettiCopy.findIndex((p) => p.id === id);
    if (index !== -1) {
      progettiCopy.splice(index, 1);
      axios.post(`${api()}/credenziali/deleteCredenziali`, {
        id: _id,
        headers: {
          authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then((res) => console.log(res))
      .catch((err) => console.error(err));

      setProgetti(progettiCopy);
      setInizialProject(progettiCopy);
    }
  };

  const addProgetto = () => {
    const progettiCopy = [...progetti];
    const newId = progettiCopy.length > 0 ? Math.max(...progettiCopy.map(p => p.id)) + 1 : 1;
    const newProgetto = {
      id: newId,
      servizio: "Nuovo Servizio",
      utente: "username_admin",
      password: "password_secret",
      piano: "base",
      email: localStorage.getItem('email') || "mail@example.com",
      note: "Note aggiuntive...",
      modify: true,
      new: true,
      createdBy: localStorage.getItem('email'),
      edit: false,
      user: localStorage.getItem('email')
    };
    progettiCopy.unshift(newProgetto);
    setProgetti(progettiCopy);
  };

  const esportTabella = () => {
    const progettiCopy = [...progetti];
    const progettiExport = progettiCopy.map(({ id, servizio, utente, password, piano, email, note }) => 
      ({ id, servizio, utente, password, piano, email, note })
    );
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(progettiExport, null, 2));
    const downloadAnchor = document.createElement('a');
    downloadAnchor.setAttribute("href", dataStr);
    downloadAnchor.setAttribute("download", `credenziali_export_${new Date().toISOString().slice(0,10)}.json`);
    document.body.appendChild(downloadAnchor);
    downloadAnchor.click();
    downloadAnchor.remove();
  };

  const changeVal = (id, field, value) => {
    const progettiCopy = [...progetti];
    const index = progettiCopy.findIndex((p) => p.id === id);
    if (index !== -1) {
      progettiCopy[index][field] = value;
      setProgetti(progettiCopy);
    }
  };

  const modifyRow = (id) => {
    const progettiCopy = [...progetti];
    const index = progettiCopy.findIndex((p) => p.id === id);
    if (index !== -1) {
      progettiCopy[index].modify = !progettiCopy[index].modify;
      progettiCopy[index].edit = true;
      setProgetti(progettiCopy);
    }
  };

  const toggleShowPassword = (id) => {
    setShowPasswords(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const copyPassword = (id, pass) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(pass);
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 2000);
    }
  };

  const saveDataFromApi = (data, path) => {
    axios.post(`${api()}/credenziali/${path}`, {
      data: data,
      headers: {
        authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then((res) => {
      setLoading(false);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    })
    .catch((err) => {
      console.error(err);
      setError(err);
      setLoading(false);
    });
  };

  const saveProject = () => {
    const progettiCopy = [...progetti];
    const progettiNew = [];
    const progettiModify = [];

    progettiCopy.forEach((p) => {
      if (p.new) {
        const { id, servizio, utente, password, piano, email, note, createdBy, user } = p;
        progettiNew.push({ id, servizio, utente, password, piano, email, note, createdBy, user });
      } else if (p.edit) {
        const { _id, id, servizio, utente, password, piano, email, note, user } = p;
        progettiModify.push({ _id, id, servizio, utente, password, piano, email, note, user });
      }
    });

    if (progettiNew.length > 0) {
      saveDataFromApi(progettiNew, 'createCredenziali');
    }
    if (progettiModify.length > 0) {
      saveDataFromApi(progettiModify, 'updateCredenziali');
    }
  };

  const filterRow = (value) => {
    setFilterQuery(value);
    const progettiCopy = [...inizialProject];
    if (!value.trim()) {
      setProgetti(progettiCopy);
    } else {
      const q = value.toLowerCase();
      const filtered = progettiCopy.filter((p) => {
        return (
          (p.id && p.id.toString().includes(q)) ||
          (p.servizio && p.servizio.toLowerCase().includes(q)) ||
          (p.utente && p.utente.toLowerCase().includes(q)) ||
          (p.piano && p.piano.toLowerCase().includes(q)) ||
          (p.email && p.email.toLowerCase().includes(q)) ||
          (p.note && p.note.toLowerCase().includes(q))
        );
      });
      setProgetti(filtered);
    }
  };

  return (
    <div id="credenziali" className="progetti-page">
      <div className="page-header">
        <div className="header-title">
          <h1>Caveau Credenziali</h1>
          <span className="count-badge">{progetti.length} Servizi</span>
        </div>
      </div>

      <div className="progetti-action-bar progetti-cont-btn">
        <button onClick={addProgetto} className='btn-action primary'>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
          Nuova Credenziale
        </button>
        
        <button onClick={esportTabella} className='btn-action secondary'>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
          Esporta JSON
        </button>

        <button className='btn-action success' onClick={saveProject}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>
          Salva Modifiche
        </button>

        <div className="search-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          <input 
            type="text" 
            className="find" 
            placeholder="Filtra credenziali..." 
            value={filterQuery}
            onChange={(e) => filterRow(e.target.value)}
          />
        </div>
      </div>

      {saveSuccess && (
        <div className="toast-success">
          ✓ Credenziali salvate con successo nel vault!
        </div>
      )}

      <div className="progetti-table-card">
        <div className="progetti-table-wrapper">
          <table className="progetti-table">
            <thead>
              <tr>
                <th style={{ width: '90px' }}>Modifica</th>
                <th style={{ width: '100px' }}>Elimina</th>
                <th style={{ width: '50px' }}>ID</th>
                <th>Servizio</th>
                <th>Utente</th>
                <th>Password</th>
                <th>Piano</th>
                <th>Email Ref.</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              {progetti.length === 0 ? (
                <tr>
                  <td colSpan="9" className="empty-table">Nessuna credenziale trovata</td>
                </tr>
              ) : (
                progetti.map((p) => (
                  <tr key={p.id} className={p.modify ? 'row-editing' : ''}>
                    <td>
                      <button 
                        onClick={() => modifyRow(p.id)} 
                        className={`btn-table-edit ${p.modify ? 'editing' : ''}`}
                      >
                        {p.modify ? 'Fatto' : 'Edit'}
                      </button>
                    </td>

                    <td>
                      <button onClick={() => requestDelete(p)} className="btn-table-del-btn" title="Elimina Credenziale">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                        Elimina
                      </button>
                    </td>

                    <td className="cell-id">#{p.id}</td>

                    {p.modify ? (
                      <>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'servizio', e.target.value)} value={p.servizio || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'utente', e.target.value)} value={p.utente || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'password', e.target.value)} value={p.password || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'piano', e.target.value)} value={p.piano || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'email', e.target.value)} value={p.email || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'note', e.target.value)} value={p.note || ''} /></td>
                      </>
                    ) : (
                      <>
                        <td className="cell-title">{p.servizio}</td>
                        <td className="cell-bold">{p.utente}</td>
                        <td>
                          <div className="password-cell">
                            <span className="password-text">
                              {showPasswords[p.id] ? p.password : '••••••••••••'}
                            </span>
                            <button 
                              className="btn-icon-subtle" 
                              onClick={() => toggleShowPassword(p.id)}
                              title={showPasswords[p.id] ? "Nascondi" : "Mostra"}
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                            </button>
                            <button 
                              className="btn-icon-subtle" 
                              onClick={() => copyPassword(p.id, p.password)}
                              title="Copia Password"
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                            </button>
                            {copiedId === p.id && <span className="copied-tooltip">Copiato!</span>}
                          </div>
                        </td>
                        <td><span className="badge-piano">{p.piano || 'base'}</span></td>
                        <td className="cell-muted">{p.email}</td>
                        <td className="cell-desc" title={p.note}>{p.note}</td>
                      </>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <ConfirmModal 
        isOpen={!!deleteTarget}
        title="Conferma Eliminazione Credenziale"
        message={`Sei sicuro di voler eliminare le credenziali per "${deleteTarget?.name}"?`}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteTarget(null)}
      />
    </div>
  );
}